import React from 'react';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import EmailIcon from '@material-ui/icons/Email';
import './Contact.css';

const Contact = () => {
  return (
    <section id='contact'>
      <h2>Contact</h2>
      <ul className='icons'>
        <li>
          <a href='mailto:catherinekomii@gmail.com' aria-label='Email'>
            <EmailIcon className='icon' />
          </a>
        </li>
        <li>
          <a
            href='https://linkedin.com/in/catherine-komi'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='LinkedIn'
          >
            <LinkedInIcon className='icon' />
          </a>
        </li>
        <li>
          <a
            href='https://github.com/catherinekomi'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='GitHub'
          >
            <GitHubIcon className='icon' />
          </a>
        </li>
      </ul>
    </section>
  );
};

export default Contact;
